import './formComponents.scss';

import { RaisedButton } from 'material-ui';
import * as React from 'react';

import { TextColor } from '../../../constants/generals';
import { TextColorBtn } from '../../../constants/generals';

export interface IButtonProps {
    label: string;
    onClick: Function;
}

export class Button extends React.PureComponent<IButtonProps, {}> {
    constructor(props: IButtonProps) {
        super(props);
    }

    public render() {
        const { label } = this.props;
        return <RaisedButton label={label} onClick={this.props.onClick as any} primary={true} style={styles} />;
    }
}

const styles: React.CSSProperties = {
    backgroundColor: TextColor,
    color: TextColorBtn
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/Button.tsx